/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 07.10.2022
 * Description : Configurations des requêtes API pour les ARE
 * Fichier : jobSearchAssistancesServices.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/JobSearchAssistances'

export default {
  getJobSearchAssistances() {
    return axios.get(API_URL + CONTROLLER)
  },
  getJobSearchAssistance(id) {
    return axios.get(API_URL + CONTROLLER + '/' + id)
  },
  postJobSearchAssistance(jobSearchAssistance) {
    return axios.post(API_URL + CONTROLLER, jobSearchAssistance)
  },
  putJobSearchAssistance(jobSearchAssistance) {
    return axios.put(
      API_URL + CONTROLLER + '/' + jobSearchAssistance.jobSearchAssistanceId,
      jobSearchAssistance
    )
  },
  deleteJobSearchAssistance(jobSearchAssistanceId) {
    return axios.delete(API_URL + CONTROLLER + '/' + jobSearchAssistanceId)
  }
}
